import { render, staticRenderFns } from "./OrganizationDetail.vue?vue&type=template&id=991b9fa8&scoped=true&"
import script from "./OrganizationDetail.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDetail.vue?vue&type=style&index=0&id=991b9fa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991b9fa8",
  null
  
)

export default component.exports